<script  type="text/jsx">
function buildApprovals (h, item) {
  if (item.approved === true && !item.isAware) {
    return (
      <span class="icon-ptt-icons-aprovar color-success fs-19"{...{
        directives: [{
          name: 'uiv-tooltip',
          value: 'Lançamento aprovado'
        }]
      }}>
      </span>
    )
  } else if (item.approved === true && item.isAware) {
    return (
      <span class="icon-ptt-icons-check color-success fs-19"{...{
        directives: [{
          name: 'uiv-tooltip',
          value: 'Lançamento validado'
        }]
      }}>
      </span>
    )
  } else if (item.approved === false) {
    return (
      <span class="icon-ptt-icons-reprovar color-danger fs-19"{...{
        directives: [{
          name: 'uiv-tooltip',
          value: 'Lançamento reprovado'
        }]
      }}>
      </span>
    )
  } else {
    return (
      <span class="icon-ptt-icons-mao color-info fs-19" {...{
        directives: [{
          name: 'uiv-tooltip',
          value: 'Lançamento pendente de aprovação'
        }]
      }}>
      </span>
    )
  }
}

function buildObservations (h, item) {
  if (item.observacao) {
    return (
      <span class="icon-ptt-icons-alerta color-warning fs-19 to-click"{...{
        directives: [{
          name: 'uiv-tooltip',
          value: item.observacao
        }]
      }}>
      </span>
    )
  }
}

export default {
  name: 'ApprovalStatus',
  functional: true,
  props: {
    item: { type: Object, required: true }
  },
  render (h, context) {
    const { item } = context.props

    const iconsToShow = []

    iconsToShow.push('approvals')
    iconsToShow.push('observations')
    const icons = {
      'approvals': () => buildApprovals(h, item),
      'observations': () => buildObservations(h, item)
    }
    return <div>{iconsToShow.map(i => icons[i]())}</div>
  }
}
</script>
